import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const H3 = styled.h3`
  font-weight: 800;
  &,
  * {
    font-size: 26px;
    line-height: 32px;
  }

  ${media.tablet`
    &, * {
      font-size: 22px;
      line-height: 32px; 
    }
  `}
`

export default H3
